export class AgendaApi {
    async index(filters) {
        try {
            const response = await axios.get('/adm/getagenda', {
                params: filters
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching agendas:', error);
            throw error;
        }
    }

    async store(data) {
        try {
            const response = await axios.post('/adm/agenda', data);

            return response.data;
        } catch (error) {
            console.error('Error store agenda:', error);
            throw error;
        }
    }

    async show(id) {
        try {   
            const response = await axios.get(`/adm/agenda/${id}`)

            return response.data
        } catch (error) {
            console.error('Error get agenda:', error);
            throw error;
        }
    }

    
    async update(data, id) {
        try {
            const response = await axios.put(`/adm/agenda/${id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error update agenda:', error);
            throw error;
        }
    }

    async destroy(id) {
        try {   
            const response = await axios.delete(`/adm/agenda/${id}`)

            return response.data
        } catch (error) {
            console.error('Error destroy agenda:', error);
            throw error;
        }
    }

    async getScheduleLink(filters) {
        try {   
            const response = await axios.get('/adm/get-link-agenda', {
                params: filters
            })

            return response.data
        } catch (error) {
            console.error('Error get schedule link:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/AgendaApi.js